import { render } from "./RestaurantHome.vue?vue&type=template&id=5f451132&scoped=true&ts=true"
import script from "./RestaurantHome.vue?vue&type=script&lang=ts"
export * from "./RestaurantHome.vue?vue&type=script&lang=ts"

import "./RestaurantHome.vue?vue&type=style&index=0&id=5f451132&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f451132"]])

export default __exports__